/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobDetails_stateTypes$ref: FragmentReference;
declare export opaque type JobDetails_stateTypes$fragmentType: JobDetails_stateTypes$ref;
export type JobDetails_stateTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: JobDetails_stateTypes$ref,
|};
export type JobDetails_stateTypes$data = JobDetails_stateTypes;
export type JobDetails_stateTypes$key = {
  +$data?: JobDetails_stateTypes$data,
  +$fragmentRefs: JobDetails_stateTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "JobDetails_stateTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '9962fbaea9ea542bce2ec32d7587d526';
module.exports = node;
